module.exports = __webpack_public_path__ + "static/img/turnplate-bg.445f43f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turnplate-bg.png
// module id = xVeb
// module chunks = 1